import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const columnDescriptionRight = {
  display: 'flex',
  alignItems: 'flex-end',
};

export const containerPaddingCss = {
  padding: '112px 0 88px',
  [MediaQueries.md]: {
    padding: '200px 0 56px',
  },
  [MediaQueries.lgAndUp]: {
    padding: '368px 0 96px',
  },
};

export const containerSizes = {
  minHeight: 360,
  [MediaQueries.sm]: {
    maxHeight: 640,
  },
  [MediaQueries.md]: {
    minHeight: 432,
  },
  [MediaQueries.lgAndUp]: {
    minHeight: 316,
  },
};

export const heading = css(typography.effra69, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  position: 'relative',
  margin: 0,
  marginBottom: 41,
  paddingRight: 30,
  [MediaQueries.md]: {
    marginBottom: 88,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 0,
  },
});

export const descriptionRight = css(typography.effra16, {
  color: colorsPalette.grey,
  fontWeights: fontWeights.regular,
  marginBottom: 0,
});
